import { logout } from "@/lib/api_controller";
import { useEffect } from "preact/hooks";
import Loading from "@/ui/components/Loading";

export default function Logout() {
  useEffect(() => {
    logout();
  }, []);

  return <Loading />;
}
